export enum AtendimentosTypes {
  'LOAD_REQUEST' = '@atendimentos/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@atendimentos/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@atendimentos/LOAD_FAILURE',

  'FILTER_ATENDIMENTOS' = '@atendimentos/FILTER_ATENDIMENTOS',
  'SORTER_ATENDIMENTOS' = '@atendimentos/SORTER_ATENDIMENTOS',
  'CLEAN_ATENDIMENTOS' = '@atendimentos/CLEAN_ATENDIMENTOS',
}

export interface Atendimento {
  protocolo: number;
  codTipSol: number;
  tipoSolicitacao: string;
  urgencia: string;
  status: string;
  nomeStatus: string;
  codParc: number;
  parceiro: string;
  listaNf: string;
  dtAbertura: string;
  hrAbertura: string;
  dtConclusao: string;
  hrConclusao: string;
  assunto: string;
  codEmbarcador: number;
  embarcador: string;
  codUsuAtend: number;
  atendente: string;
  codcidDestino: number;
  naoLidos: number;
}

export interface IFiltroAtendimentos {
  embarcador: string;
  numNota: number;
  protocolo: number;
  status: string;
  tipoSolicitacao: string;
  dataAbertura: string;
  dataConclusao: string;
  atendente: string;
  classificacaoUrgencia: string;
}

export interface IFilter {
  filter: object;
  codParceiro: number;
}

export interface Pagination {
  total: number;
  pageSize: number;
  current: number;
  showSizeChanger: boolean;
  pageSizeOptions: string[];
}

export interface Sorter {
  sortBy: string;
  ascendance: string;
}

export interface AtendimentosState {
  readonly data: Atendimento[];

  readonly loading: boolean;
  readonly error: boolean;
  readonly filter?: IFilter;
  readonly pagination: Pagination;
  readonly sorter?: any;
}
